<template>
  <kst-section :title="sectionTitle">
    <template #top-right>
      <kst-button action-mode
        class="is-primary"
        tag="button"
        :label="Model.ItemPackaging.Module.FullName"
        :moduleType="Model.ItemPackaging.ModuleType.New"
        @click="handleAdd_Packaging"
      />
    </template>

    <kst-warning class="mb-4" :items="packagingWarning"/>

    <List :userData="userData" :userPackagings="userPackagings"/>

    <kst-input class="ks-display-none" field="ActivePackaging" :data="userData" :catalog="Catalog"/>
    <kst-errors class="mt-4" :items="userData.PackagingsErrors"/>
  </kst-section>
</template>

<script>
import Catalog from "../ItemCatalog.js";
import Info from "../ItemInfo.js";
import Model from "../ItemModel.js";

import List from "./ItemEdit_Packagings_List";

export default {
  components: {
    List
  },
  props: {
    userData: Object,
    userPackagings: Array
  },
  data: () => ({
    Catalog: Catalog,
    Model: Model
  }),
  computed: {
    packagingWarning() {
      return [
        Info.Message.Edit_ExistingPackaging
      ]
    },
    sectionTitle() {
      return Info.Section.Packaging.Title;
    }
  },
  methods: {
    handleAdd_Packaging() {
      const packaging = Model.createPackaging();
      this.userPackagings.push(packaging);
      Model.updatePackagingsErrors(this.userData, this.userPackagings);
    }
  }
}
</script>